import { Link } from "@/components/common/Link";
const projects = [{
  id: 1,
  label: "INDUSTRIAL",
  title: "\xA0demolition and removal\xA0\xA0",
  image: "https://sampsonconcreteandmasonry.net/wp-content/uploads/2026/04/image_b78q9rau.png?v=cwvkqfn0d1h",
  link: "/ProjectsPage"
}, {
  id: 2,
  label: "INFRASTRUCTURE",
  title: "CONCRETE PORCHES\xA0",
  image: "https://sampsonconcreteandmasonry.net/wp-content/uploads/2026/04/IMG_4221-scaled.jpg?v=acb3xsh7njd",
  link: "/ProjectsPage"
}, {
  id: 3,
  label: "URBAN",
  title: "CONCRETE STAIRS",
  image: "https://sampsonconcreteandmasonry.net/wp-content/uploads/2026/04/IMG_4236.jpg?v=izwmgvpuky",
  link: "/ProjectsPage"
}];
export default function FeaturedProjects() {
  return <section data-section-id="187643" id="project-portfolio" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-8 md:px-16">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, i) => <Link key={project.id} to={project.link} data-index={i} className="group relative flex h-[400px] flex-col justify-end overflow-hidden bg-card border-t-2 border-accent p-8 text-card-foreground transition-all duration-300 hover:-translate-y-1 hover:shadow-xl rounded-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background">
              <img src={project.image} alt={project.title} className="absolute inset-0 h-full w-full object-cover opacity-40 grayscale transition-transform duration-700 group-hover:scale-110 group-hover:grayscale-0" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-accent/10 transition-all duration-300 group-hover:backdrop-blur-[2px]" />

              <div className="relative z-10 flex flex-col gap-3">
                
                <h3 className="font-default text-3xl text-foreground md:text-4xl">
                  {project.title}
                </h3>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}